import { Injectable } from '@angular/core';
import { EnvService } from './env.service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { CallBackTransformService } from './call-back-transform.service';

@Injectable({
  providedIn: 'root'
})
export class CustomizationService {

  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService,
  ) { }
  public brandingValueSet = new BehaviorSubject<any>(null);
  public brandingValueCast = this.brandingValueSet.asObservable()

  getImageData() {
    const url = this.envService.apiUrl + 'branding-logos';
    return this.http.get<any>(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  saveImage(data, type): Observable<any> {
    const url = this.envService.apiUrl + 'branding-image?brandingLogoType=' + type;
    const config = { headers: {fileFlag: 'true' } };
    return this.http.post(url, data, config).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  saveAgencyBranding(data) {
    const url = this.envService.apiUrl + 'add-agency-branding';
    return this.http.post(url, data).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }
}
